/*
 * @Date: 2020-08-11 19:24:21
 * @LastEditors: lingbinzzz
 * @LastEditTime: 2020-09-22 16:06:52
 * @FilePath: \pc-mall\src\constant\config.js
 */
export const config = {
  BASE_URL: '',
  filterReservationDaily: '19:00-21:00',
  isShowFilterReservationDaily: false
}
